export default __webpack_public_path__ + "static/media/up.ad6bcc61.svg";